export const DATA_AUTOMATION_VALUE = "technologies-cell";
